// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + (chunkId === 6378 ? "grapesjs" : chunkId) + "." + {"1268":"aa8b1165","5591":"aa8b1165","6378":"d8397b61"}[chunkId] + ".chunk.css";
};